import { Theme } from "@emotion/react";
import { mdsCommonTheme } from "../common";

export const mdsThemeHarvest: Theme = {
  ...mdsCommonTheme,

  colors: {
    ...mdsCommonTheme.colors,

    text: {
      contrast: mdsCommonTheme.colors.ink[400],
      primary: mdsCommonTheme.colors.graphite[900],
      secondary: mdsCommonTheme.colors.graphite[800],
      tertiary: mdsCommonTheme.colors.graphite[600],
      onAccent: mdsCommonTheme.colors.graphite[0],
      emphasis: mdsCommonTheme.colors.blueprint[400],
      positive: mdsCommonTheme.colors.success,
      danger: mdsCommonTheme.colors.editor[500],
      link: {
        default: mdsCommonTheme.colors.blueprint[400],
        hover: mdsCommonTheme.colors.blueprint[500],
      },
      editor: {
        metadata: mdsCommonTheme.colors.graphite[800], // TODO: Not in Figma
      },
    },
    icon: {
      primary: mdsCommonTheme.colors.graphite[800],
      secondary: mdsCommonTheme.colors.graphite[700],
      placeholder: mdsCommonTheme.colors.graphite[600],
      onAccent: mdsCommonTheme.colors.graphite[0],
      brand: mdsCommonTheme.colors.editor[300],
      selected: mdsCommonTheme.colors.blueprint[300],
      emphasis: mdsCommonTheme.colors.blueprint[300],
      danger: mdsCommonTheme.colors.editor[400],
      positive: mdsCommonTheme.colors.success, // TODO: Not in Figma
      onChromeInactive: mdsCommonTheme.colors.latte[300],
    },
    surface: {
      chrome: mdsCommonTheme.colors.canvas[100],
      pane: mdsCommonTheme.colors.graphite[0],
      paneHeader: mdsCommonTheme.colors.graphite[100],
      chat: mdsCommonTheme.colors.graphite[200],
      menu: mdsCommonTheme.colors.graphite[0],
      modal: mdsCommonTheme.colors.graphite[0],
      popover: mdsCommonTheme.colors.graphite[0],
      preview: mdsCommonTheme.colors.graphite[0],
      previewHeader: mdsCommonTheme.colors.graphite[100],
      tooltip: mdsCommonTheme.colors.graphite[800],
      onboarding: mdsCommonTheme.colors.latte[100],
      onboardingSubtle: mdsCommonTheme.colors.canvas[0],
      headsUp: {
        default: mdsCommonTheme.colors.graphite[100],
        hover: mdsCommonTheme.colors.graphite[200],
      },
      toast: {
        default: mdsCommonTheme.colors.graphite[0],
        danger: mdsCommonTheme.colors.editor[0],
      },
      overlay: {
        default: "rgba(0, 0, 0, 0.5)",
        onboarding: mdsCommonTheme.colors.transparentCanvas,
      },
    },
    border: {
      default: mdsCommonTheme.colors.graphite[200],
      onAccent: mdsCommonTheme.colors.graphite[300],
      ghost: mdsCommonTheme.colors.graphite[0],
      surface: mdsCommonTheme.colors.graphite[100],
      emphasis: mdsCommonTheme.colors.blueprint[200],
      chrome: mdsCommonTheme.colors.canvas[100],

      input: {
        default: {
          default: mdsCommonTheme.colors.graphite[400],
          focused: mdsCommonTheme.colors.graphite[500],
          danger: mdsCommonTheme.colors.editor[400],
        },
        brand: {
          default: mdsCommonTheme.colors.transparent,
          focused: mdsCommonTheme.colors.editor[300],
        },
        emphasis: {
          default: mdsCommonTheme.colors.graphite[400],
          focused: mdsCommonTheme.colors.blueprint[200],
        },
      },
      button: {
        marketing: {
          default: mdsCommonTheme.colors.ink[400],
          hover: mdsCommonTheme.colors.editor[300],
        },
      },
    },
    background: {
      activeTab: mdsCommonTheme.colors.blueprint[300],
      diff: mdsCommonTheme.colors.blueprint[0],
      codeBlock: mdsCommonTheme.colors.graphite[800],
      textHighlight: mdsCommonTheme.colors.blueprint[100],
      inlineCode: mdsCommonTheme.colors.graphite[200],
      list: {
        default: mdsCommonTheme.colors.graphite[0],
        hover: mdsCommonTheme.colors.graphite[100],
        selected: mdsCommonTheme.colors.blueprint[100],
        deepsearch: mdsCommonTheme.colors.blueprint[0],
        uploading: "#E9E9E9",
        pending: "#E6EDFF",
        error: "#FFE8E6",
      },
      menu: {
        default: mdsCommonTheme.colors.graphite[0],
        hover: mdsCommonTheme.colors.graphite[100],
        selected: mdsCommonTheme.colors.graphite[200],
        emphasized: mdsCommonTheme.colors.blueprint[0],
      },
      input: {
        default: {
          default: mdsCommonTheme.colors.graphite[0],
          focused: mdsCommonTheme.colors.graphite[100],
        },
        inline: {
          default: mdsCommonTheme.colors.transparent,
          focused: mdsCommonTheme.colors.graphite[200],
          hover: mdsCommonTheme.colors.graphite[200],
        },
        chrome: {
          default: mdsCommonTheme.colors.canvas[0],
          focused: mdsCommonTheme.colors.latte[100],
          hover: mdsCommonTheme.colors.latte[100], // TODO: Not in Figma
        },
        onAccent: {
          default: mdsCommonTheme.colors.graphite[100],
          focused: mdsCommonTheme.colors.graphite[0],
        },
      },
      message: {
        user: mdsCommonTheme.colors.graphite[100],
        mem: mdsCommonTheme.colors.transparent,
      },
      badge: {
        default: mdsCommonTheme.colors.graphite[200],
        emphasis: mdsCommonTheme.colors.blueprint[100],
        moreEmphasis: mdsCommonTheme.colors.blueprint[200],
        notification: mdsCommonTheme.colors.editor[300],
        danger: mdsCommonTheme.colors.editor[0],
      },
      banner: {
        danger: mdsCommonTheme.colors.editor[0],
        emphasis: mdsCommonTheme.colors.blueprint[100],
        default: mdsCommonTheme.colors.graphite[200],
      },
      card: {
        emphasis: mdsCommonTheme.colors.blueprint[100],
        default: mdsCommonTheme.colors.graphite[100],
      },
      illustration: {
        default: mdsCommonTheme.colors.latte[100],
        onAccent: mdsCommonTheme.colors.graphite[300],
        contrast: mdsCommonTheme.colors.graphite[0],
      },
      skeleton: {
        start: mdsCommonTheme.colors.graphite[300],
        middle: mdsCommonTheme.colors.graphite[100],
        end: mdsCommonTheme.colors.graphite[300],
      },
      voice: {
        self: mdsCommonTheme.colors.blueprint[0],
        others: mdsCommonTheme.colors.graphite[100],
      },
      button: {
        default: {
          default: mdsCommonTheme.colors.graphite[200], // TODO: Not in Figma
          hover: mdsCommonTheme.colors.graphite[300], // TODO: Not in Figma
        },
        contrast: {
          default: mdsCommonTheme.colors.graphite[900],
          hover: mdsCommonTheme.colors.graphite[800],
        },
        chip: {
          default: mdsCommonTheme.colors.graphite[200],
          hover: mdsCommonTheme.colors.graphite[300],
          selectedNegative: mdsCommonTheme.colors.editor[0],
          selectedPositive: mdsCommonTheme.colors.successLight,
        },
        toggle: {
          default: mdsCommonTheme.colors.graphite[100],
          hover: mdsCommonTheme.colors.graphite[200],
          toggled: mdsCommonTheme.colors.blueprint[100],
          toggledHover: mdsCommonTheme.colors.blueprint[200],
        },
        contrastAccent: {
          default: mdsCommonTheme.colors.graphite[0],
          hover: mdsCommonTheme.colors.graphite[100],
        },
        emphasis: {
          default: mdsCommonTheme.colors.blueprint[300],
          hover: mdsCommonTheme.colors.blueprint[400],
        },
        transparent: {
          default: mdsCommonTheme.colors.transparent,
          hover: mdsCommonTheme.colors.graphite[200],
        },
        navigation: {
          default: mdsCommonTheme.colors.canvas[100],
          hover: mdsCommonTheme.colors.latte[100],
        },
        chrome: {
          default: mdsCommonTheme.colors.canvas[0],
          hover: mdsCommonTheme.colors.latte[100],
        },
        subtle: {
          default: mdsCommonTheme.colors.canvas[0],
          hover: mdsCommonTheme.colors.latte[100],
        },
        danger: {
          default: mdsCommonTheme.colors.transparent,
          hover: mdsCommonTheme.colors.editor[0],
        },
        tabBar: {
          default: mdsCommonTheme.colors.graphite[100],
          hover: mdsCommonTheme.colors.graphite[200],
          active: mdsCommonTheme.colors.graphite[0],
        },
        onChrome: {
          default: mdsCommonTheme.colors.transparent,
          hover: mdsCommonTheme.colors.latte[200],
        },
        onAccent: {
          default: mdsCommonTheme.colors.transparent,
          hover: mdsCommonTheme.colors.graphite[300],
        },
        brand: {
          default: mdsCommonTheme.colors.editor[300],
          hover: mdsCommonTheme.colors.editor[200],
        },
        emphasisLight: {
          default: mdsCommonTheme.colors.blueprint[100],
          hover: mdsCommonTheme.colors.blueprint[200],
        },
        contextChipFromUser: {
          default: mdsCommonTheme.colors.graphite[200],
          hover: mdsCommonTheme.colors.graphite[300],
        },
        dangerFilled: {
          default: mdsCommonTheme.colors.editor[0],
          hover: mdsCommonTheme.colors.editor[100],
        },
        contextChipFromMem: {
          default: mdsCommonTheme.colors.graphite[100],
          hover: mdsCommonTheme.colors.graphite[200],
        },
        floatingIcon: {
          default: mdsCommonTheme.colors.graphite[0],
          hover: mdsCommonTheme.colors.graphite[100],
        },
      },
    },
  },

  shadows: {
    ...mdsCommonTheme.shadows,
    surface: "0 4px 6px 0 rgba(55, 55, 55, 0.10)",
    tabScrollButtonRight: "-4px 0 6px 0 rgba(55, 55, 55, 0.10)", // TODO: Not in Figma
    tabScrollButtonLeft: "4px 0 6px 0 rgba(55, 55, 55, 0.10)", // TODO: Not in Figma
  },
};
